<div class="flex flex-col external-package-dialog p-26" style="height: 100%;">
    <div *ngIf="!dataLoading" class="flex flex-row justify-between items-center">
        <div class="flex flex-col">
            <div *ngIf="data?.dataLoaded" class=" flex flex-row mat-headline-6 mb-0">{{'INSTANCE_DETAILS.INFRA_UPGRADE'
                | transloco }}</div>
            <div *ngIf="data?.dataLoaded" class=" flex flex-row mt-8 fs-14 mb-0">
                {{'INSTANCE_DETAILS.CURRENT_SOLUTION_VERSION' | transloco }} : {{data?.instance?.version}} |
                {{'INSTANCE_DETAILS.INFRA_VERSION' | transloco }} : {{data?.instance?.infraSolutionVersion || '-' }}</div>
        </div>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="onCancelClick()"></mat-icon>
    </div>
    <mat-divider *ngIf="!dataLoading" class="neutral-blue-6 mt-16 mb-20"></mat-divider>
    <div class="flex flex-row mat-body-2 fw-400" [ngClass]="{'disabled': infraLoader}">
        {{'INSTANCE_DETAILS.SELECT_INFRA_VERSION' | transloco}}
        <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="my-tooltip right"
            [matTooltip]="'INSTANCE_DETAILS.SELECT_INFRA_VERSION' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
    </div>

    <div class="flex flex-row items-center gap-x-6 mt-4">
            <mat-select [attr.aria-label]="'Choose version'" class="w-240 version-dropdown" placeholder="{{'INSTANCE_DETAILS.CHOOSE' | transloco}}" [ngClass]="{'disabled': infraLoader}"
                [value]="selectedVersion" (selectionChange)="onVersionChange($event.value)" [panelClass]="'version-select-panel'">
                <mat-option *ngIf="!dropdownLoader">
                    <div class="flex items-center justify-center spinner-width mb-16 mt-16">
                        <mat-spinner class="mr-8" diameter="20" color="primary" mode="indeterminate">
                        </mat-spinner>
                    </div>
                </mat-option>
                <ng-container *ngIf="dropdownLoader && versions?.length > 0; else noVersions" aria-live="polite">
                    <ng-container *ngFor="let version of versions; let i = index">
                        <mat-option [value]="version">{{ version.version }}</mat-option>
                        <mat-divider *ngIf="i < versions.length - 1"></mat-divider>
                    </ng-container>
                </ng-container>
                <ng-template #noVersions>
                    <mat-option *ngIf="dropdownLoader" disabled>
                        {{'INSTANCE_DETAILS.NO_INFRA_VERSION_FOUND' | transloco}}
                    </mat-option>
                </ng-template>
            </mat-select>
            <button class="white" type="button" [disabled]="!selectedVersion || showMinAlert " (click)="checkInfraUpdates()"
                [ngClass]="{'disabled': !selectedVersion || infraLoader}">
                {{'INSTANCE_DETAILS.CHECK_FOR_UPDATES' | transloco}}
            </button>
    </div>
    @if (showMinAlert) {
   <div class="flex flex-col neutral-blue-6 items-center text-center mt-56 mb-14">
    <mat-icon svgIcon="warning_amber" class="w-40 h-40 amber_color mb-8"></mat-icon>
    <div class="mat-body-2 fw-400" [innerHtml]="title"></div>
   </div>
    }
    @if (infraLoader) {
    <div class="flex flex-col neutral-blue-6 items-center text-center mt-156 mb-14">
        <div><mat-progress-bar mode="indeterminate" class="progress-bar mb-12"></mat-progress-bar></div>
        <div class="mat-body-2 fw-400" [innerHtml]="infraLoaderMessage"></div>
    </div>
    }
    @if (isNotInfraUpdate && !infraLoader && !showMinAlert) {
    <div class="flex flex-col neutral-blue-6 items-center text-center mt-124 mb-14">
        <img class="mr-8 w-106 h-106 mb-16" src="/assets/images/service_not_found.png"/>
        <div class="mat-body-2 fw-400" [innerHtml]="infraUpgradeMessage"></div>
    </div>
    }
    @if (!infraLoader && !showMinAlert && (infraData?.length > 0)) {
    <div class="flex flex-col border-radius route-table mt-16 envt-jobs">
    <app-environment-table class="runbook-table" [dataLoading]="infraLoader" [displayColumns]="displayColumns" [initialDataSource]="infraData" [dataSourceLength]="true" pageName="infraUpgrade"></app-environment-table>
    </div>
     }

    <span class="flex-auto"></span>
    <mat-divider class="neutral-2 mt-16 mb-20"></mat-divider>
    <div class="pt-4 pb-16">
        <div class="flex flex-row justify-end gap-x-6">
            <button class="white" type="button" (click)="onCancelClick()">
                {{ 'BUTTONS.CANCEL' | transloco }}
            </button>
            <button [ngClass]="{'disabled': !isVersionAvailable || showMinAlert || infraLoader }" class="accent" type="button"
                (click)="confirmSubmit()">
                {{ 'BUTTONS.SUBMIT' | transloco }}
            </button>
        </div>
    </div>
</div>
